import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getVisit, IVisit, updateVisit } from "../../../redux/modules/visits";
import { getServices, IService } from "../../../redux/modules/services";
import VisitForm from "../../VisitForm";
import { withRouter } from "../../../hooks/withRouter";
import { RootState } from "../../../redux";
import { formatDate } from "../../../utils";
import "./visit-page.css";

interface VisitPageProps {
  visits: IVisit[];
  services: IService[];
  router?: { params?: { id?: string } };
  updateVisit?: (visit: Partial<IVisit>) => Promise<void>;
  getVisit?: (visitId: string) => void;
  getServices?: (page: number) => void;
}

class VisitPage extends React.Component<VisitPageProps> {
  render() {
    const pageId = this.props?.router?.params?.id;
    if (!pageId) {
      return (
        <div className="visit-page">
          <div className="visit-page__empty">
            <p className="visit-page__empty-text">Візит не знайдено</p>
          </div>
        </div>
      );
    }
    const visit = this.props.visits.find((v) => v.id === +pageId);
    if (!visit) {
      return (
        <div className="visit-page">
          <div className="visit-page__loading">
            <p className="visit-page__loading-text">Завантаження візиту...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="visit-page">
        <div className="visit-page__header">
          <div className="visit-page__header-content">
            <div className="visit-page__header-info">
              <h1 className="visit-page__title">Редагувати Візит</h1>
              <p className="visit-page__subtitle">
                {visit.title && `${visit.title}`}
                {visit.date && ` • ${formatDate(visit.date)}`}
                {visit.client && ` • ${visit.client.name}`}
              </p>
            </div>
            <Link to={`/client/${visit.clientId}?tab=visits`} className="visit-page__back-link">
              <span className="visit-page__back-icon">←</span>
              Всі візити клієнта
            </Link>
          </div>
        </div>
        <div className="visit-page__form-container">
          <VisitForm visit={visit} saveHandler={this.props.updateVisit} />
        </div>
      </div>
    );
  }

  componentDidMount() {
    const visitId = this.props?.router?.params?.id;
    if (!visitId || !this.props.getVisit) {
      return;
    }
    this.props.getVisit(visitId);
    this.props.getServices && this.props.getServices(0);
  }
}

const mapStateToProps = (state: RootState) => {
  return { visits: state.visits, services: Object.values(state.servicesState.services) };
};

export default withRouter(connect(mapStateToProps, { getVisit, updateVisit, getServices })(VisitPage));
